"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Input = _interopRequireDefault(require("@micado-digital/react-form/Input"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _CartContext = _interopRequireDefault(require("../../context/CartContext"));
var _updateVoucher = _interopRequireWildcard(require("../../utils/cart/updateVoucher"));
var _de = _interopRequireDefault(require("../../locals/de.json"));
var _en = _interopRequireDefault(require("../../locals/en.json"));
var _it = _interopRequireDefault(require("../../locals/it.json"));
var _Voucher = _interopRequireDefault(require("./Voucher.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Alert = (0, _component.default)(() => import("@material-ui/lab/Alert"));
const LoadingIcon = (0, _component.default)(() => import("../../components/LoadingIcon"));
const Voucher = _ref => {
  let {
    lang
  } = _ref;
  const {
    setCart
  } = (0, _react.useContext)(_CartContext.default);
  const [loading, setLoading] = (0, _react.useState)(false);
  const [messageObj, setMessageObj] = (0, _react.useState)(null);
  const [value, setValue] = (0, _react.useState)("");
  const timeout = (0, _react.useRef)(null);
  const css = (0, _Voucher.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  const hasValue = (0, _react.useMemo)(() => {
    return value !== "";
  }, [value]);
  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    const response = await (0, _updateVoucher.default)(value);
    const {
      msg
    } = response || {};
    setLoading(false);
    setValue("");
    if (msg) {
      showMessage(l("reactShop.messages.errors.".concat(_updateVoucher.UPDATE_VOUCHER_ERRORS[msg]), {
        value
      }), "error");
      return;
    }
    localStorage.setItem("mco-shop-cart", JSON.stringify(response));
    setCart(response);
    showMessage(l("reactShop.messages.success.VOUCHER_VALID", {
      value
    }), "success");
  };
  const showMessage = (message, type) => {
    setMessageObj({
      message,
      type
    });
    timeout.current = setTimeout(() => {
      setMessageObj(null);
    }, 2000);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.voucher, "mco-shop-voucher")
  }, /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: l("reactShop.voucher.label"),
    name: "voucherCode",
    TextfieldProps: {
      value: value,
      variant: "outlined",
      onChange: e => {
        setValue(e.target.value);
      }
    }
  }), hasValue && /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: (0, _clsx.default)(css.button, "mco-shop-voucher__button", {
      [css.isLoading]: loading
    }),
    color: "primary",
    disabled: loading,
    fullWidth: true,
    type: "submit",
    variant: "outlined"
  }, loading ? /*#__PURE__*/_react.default.createElement(LoadingIcon, null) : /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.voucher.button",
    l: l
  }))), !(0, _isEmpty.default)(messageObj) && /*#__PURE__*/_react.default.createElement(Alert, {
    className: css.message,
    severity: messageObj === null || messageObj === void 0 ? void 0 : messageObj.type
  }, messageObj === null || messageObj === void 0 ? void 0 : messageObj.message));
};
var _default = exports.default = Voucher;